const CTAContent = () => {
  return (
    <div className="mb-12">
      <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
        Rozpocznij swoją transformację biznesową już dziś
      </h2>
      <p className="text-xl text-gray-300">
        Dołącz do grona zadowolonych właścicieli szkół językowych i rozpocznij budowę
        stabilnego biznesu
      </p>
    </div>
  );
};

export default CTAContent;